import profile from "../../../../content/pages/home/charis_profile.jpeg";
import * as React from 'react';
export default {
  profile,
  React
};